import { Dialog, DialogContent, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import type { ReactNode } from "react";

export function Showcase() {
  return (
    <TooltipProvider>
      <div className="flex flex-col gap-10 py-8">
        <Section title="Button">
          <div className="flex gap-3">
            <button type="button" className="iris-btn iris-btn--primary">
              Primary
            </button>
            <button type="button" className="iris-btn">
              Secondary
            </button>
            <button
              type="button"
              className="iris-btn"
              style={{ background: "transparent", border: "1px solid transparent" }}
            >
              Ghost
            </button>
            <button
              type="button"
              className="iris-btn"
              style={{
                background: "var(--iris-neon-pink)",
                color: "var(--iris-bg-0)",
                borderColor: "var(--iris-neon-pink)",
              }}
            >
              Danger
            </button>
          </div>
          <div className="flex items-center gap-3">
            <button type="button" className="iris-btn text-xs">
              sm
            </button>
            <button type="button" className="iris-btn">
              md
            </button>
            <button type="button" className="iris-btn text-base px-6 py-3">
              lg
            </button>
            <button type="button" className="iris-btn" disabled>
              disabled
            </button>
          </div>
        </Section>

        <Section title="Input">
          <div className="grid grid-cols-2 gap-4 max-w-xl">
            <div className="flex flex-col gap-1.5">
              <label className="text-xs text-[var(--iris-fg-3)]">
                Normal
                <input placeholder="type…" className="iris-input w-full" />
              </label>
            </div>
            <div className="flex flex-col gap-1.5">
              <label className="text-xs text-[var(--iris-fg-3)]">
                With error
                <input
                  className="iris-input w-full"
                  style={{ borderColor: "var(--iris-neon-pink)" }}
                />
              </label>
              <span className="text-xs text-[var(--iris-neon-pink)]">required</span>
            </div>
          </div>
        </Section>

        <Section title="Card">
          <div className="grid grid-cols-3 gap-4">
            <div className="iris-card" style={{ padding: 18 }}>
              Default card
            </div>
            <div className="iris-card" style={{ padding: 18 }}>
              Another
            </div>
            <div className="iris-card" style={{ padding: 18 }}>
              Third
            </div>
          </div>
        </Section>

        <Section title="Dialog">
          <Dialog>
            <DialogTrigger asChild>
              <button type="button" className="iris-btn iris-btn--primary">
                Open dialog
              </button>
            </DialogTrigger>
            <DialogContent>
              <DialogTitle className="mb-3 text-lg font-semibold">Dialog title</DialogTitle>
              <p className="text-sm text-[var(--iris-fg-3)]">Hello from the dialog.</p>
            </DialogContent>
          </Dialog>
        </Section>

        <Section title="DropdownMenu">
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <button type="button" className="iris-btn">
                Open menu
              </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent>
              <DropdownMenuItem>One</DropdownMenuItem>
              <DropdownMenuItem>Two</DropdownMenuItem>
              <DropdownMenuItem>Three</DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </Section>

        <Section title="Tabs">
          <Tabs defaultValue="a">
            <TabsList>
              <TabsTrigger value="a">A</TabsTrigger>
              <TabsTrigger value="b">B</TabsTrigger>
              <TabsTrigger value="c">C</TabsTrigger>
            </TabsList>
            <TabsContent value="a">Panel A</TabsContent>
            <TabsContent value="b">Panel B</TabsContent>
            <TabsContent value="c">Panel C</TabsContent>
          </Tabs>
        </Section>

        <Section title="Table">
          <div className="w-full overflow-auto">
            <table className="iris-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>tg_news_intl</td>
                  <td>ok</td>
                </tr>
                <tr>
                  <td>tg_daily</td>
                  <td>warn</td>
                </tr>
              </tbody>
            </table>
          </div>
        </Section>

        <Section title="Tooltip">
          <Tooltip>
            <TooltipTrigger asChild>
              <button
                type="button"
                className="iris-btn"
                style={{ background: "transparent", border: "1px solid transparent" }}
              >
                Hover me
              </button>
            </TooltipTrigger>
            <TooltipContent>This is a tooltip</TooltipContent>
          </Tooltip>
        </Section>
      </div>
    </TooltipProvider>
  );
}

function Section({ title, children }: { title: string; children: ReactNode }) {
  return (
    <div>
      <h2 className="mb-3 text-sm uppercase tracking-wider text-[var(--iris-fg-3)]">{title}</h2>
      <div className="flex flex-col gap-3">{children}</div>
    </div>
  );
}
